/*
Don't change this file manually.
It is autogenerated by @plone/registry.
Instead, change the "addons" registration in the app.
*/
import plonevoltoSlate from '@plone/volto-slate';
import larissaMyproject from 'larissa-myproject';

const addonsInfo = [{"name":"@plone/volto-slate","version":"19.0.4","isPublishedPackage":true,"isRegisteredAddon":false,"modulePath":"/app/core/packages/volto-slate/src","hasServerConfig":false,"packageJson":"/app/core/packages/volto-slate/package.json","basePath":"/app/core/packages/volto-slate","tsConfigPaths":null,"addons":[]},{"name":"larissa-myproject","version":"1.0.0-alpha.0","isPublishedPackage":true,"isRegisteredAddon":true,"modulePath":"/app/packages/larissa-myproject/src","hasServerConfig":false,"packageJson":"/app/packages/larissa-myproject/package.json","basePath":"/app/packages/larissa-myproject","tsConfigPaths":[null,{"@plone/volto/*":["../../core/packages/volto/src/*"],"larissa-myproject/*":["./src/*"]}],"addons":[]}];
export { addonsInfo };

const safeWrapper = (func) => (config) => {
  const res = func(config);
  if (typeof res === 'undefined') {
    throw new Error("Configuration function doesn't return config");
  }
  return res;
}

const load = (config) => {
  const addonLoaders = [plonevoltoSlate, larissaMyproject];
  if(!addonLoaders.every((el) => typeof el === "function")) {
    throw new TypeError(
      'Each addon has to provide a function applying its configuration to the projects configuration.',
    );
  }
  return addonLoaders.reduce((acc, apply) => safeWrapper(apply)(acc), config);
};
export default load;
